"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const interfaces_1 = require("./interfaces");
const user_1 = require("./services/user");
const jwt_1 = require("./jwt");
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
const client_1 = require("react-dom/client");
const App_1 = __importDefault(require("./App"));
const env_config_1 = __importDefault(require("./env.config"));
const logout_1 = require("./dataLayer/apisWithoutCache/slr/logout");
const tgtHelper_1 = require("./helpers/tgtHelper");
class Auth {
    constructor() {
        this.initCalled = false;
        this.state = null;
        this.getState = (isInit = false) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const cookies = (0, helpers_1.parseCookies)();
            const userInfo = (0, helpers_1.jsonSafeGet)(cookies[env_config_1.default.COOKIES_PREFIX + "userInfo"]);
            const sub = ((_a = this === null || this === void 0 ? void 0 : this.identity) === null || _a === void 0 ? void 0 : _a.id) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id);
            if (!sub)
                return interfaces_1.EnumLoginState.LoggedOut;
            try {
                if (isInit) {
                    this.identity = (yield (0, user_1.getUserData)());
                }
                else if (!((_b = this === null || this === void 0 ? void 0 : this.identity) === null || _b === void 0 ? void 0 : _b.id) || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
                    this.identity = (yield (0, user_1.getUserData)());
                }
            }
            catch (e) {
                console.error("Error While Get User Data->", e.message);
            }
            return ((_c = this.identity) === null || _c === void 0 ? void 0 : _c.id) && this.identity.id > 0
                ? interfaces_1.EnumLoginState.LoggedIn
                : interfaces_1.EnumLoginState.LoggedOut;
        });
    }
    static getInstance() {
        if (!Auth.instance) {
            Auth.instance = new Auth();
        }
        return Auth.instance;
    }
    init(domainName, rootElement, language, country, platform, deviceUUID, cityId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initCalled) {
                console.error("Trying to call Auth.init multiple times, only first call will work!");
                return this.state;
            }
            this.initCalled = true;
            this.domainName = domainName;
            this.rootElement = rootElement;
            this.language = language;
            this.country = country;
            this.platform = platform;
            this.cityId = cityId;
            this.auth = yield (0, tgtHelper_1.generateRequiredCookiesAndGetToken)(this.platform);
            if (this.rootElement) {
                const _ssoRoot = document === null || document === void 0 ? void 0 : document.getElementById(this.rootElement);
                const ssoRoot = (0, client_1.createRoot)(_ssoRoot);
                ssoRoot.render((0, jsx_runtime_1.jsx)(App_1.default, {}));
            }
            try {
                const state = (this.state = yield this.getState(true));
                return { state };
            }
            catch (err) {
                console.error(`Error while getting member data`, err);
                throw err;
            }
        });
    }
    getToken(authenticated, verified = false, onContinueCb = () => { }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.controller) {
                this.controller.abort();
            }
            this.controller = new AbortController();
            const signal = this.controller.signal;
            let screenType = (authenticated && !this.identity) ? constants_1.ScreenConstants.LOGIN_SCREEN :
                (verified && ((_a = this.identity) === null || _a === void 0 ? void 0 : _a.isNewUser)) ? constants_1.ScreenConstants.COMPLETE_REGISTER : null;
            if (screenType) {
                this.screenType = screenType;
                document.dispatchEvent(new CustomEvent(constants_1.OPEN_SSO_MODAL_EVENT, {
                    detail: {
                        country: this.country,
                        deviceUUID: this.auth.deviceUUID,
                        platform: this.platform,
                        language: this.language,
                        cityId: this.cityId,
                    },
                }));
                yield new Promise((resolve, reject) => {
                    const loginSuccessHandler = () => {
                        window[constants_1.ON_CONTINUE_CB] = onContinueCb;
                        resolve("jwt");
                        document.removeEventListener(constants_1.LOGIN_SUCCESS_CONSTANT, loginSuccessHandler);
                    };
                    const abortHandler = () => {
                        document.removeEventListener(constants_1.LOGIN_SUCCESS_CONSTANT, loginSuccessHandler);
                    };
                    document.addEventListener(constants_1.LOGIN_SUCCESS_CONSTANT, loginSuccessHandler);
                    signal.addEventListener("abort", abortHandler);
                });
            }
            const state = yield this.getState();
            if (authenticated && state === interfaces_1.EnumLoginState.LoggedOut) {
                return yield this.getToken(authenticated, verified, onContinueCb);
            }
            const jwt = new jwt_1.Jwt();
            const payload = {
                at0: this.auth.t,
                aud: this.platform,
                sub: this.identity ? (_b = JSON.parse((0, helpers_1.getCookie)(env_config_1.default.COOKIES_PREFIX + 'userInfo'))) === null || _b === void 0 ? void 0 : _b['id'] : this.auth.deviceUUID,
            };
            return jwt.generate_jwt(this.auth.k, payload);
        });
    }
    authenticate(redirectUrl, verified = false) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const country = this.country;
            const deviceUUID = this.auth.deviceUUID;
            const platform = this.platform;
            const language = this.language;
            const cityId = this.cityId;
            let dialogType = "";
            if ((_a = this.identity) === null || _a === void 0 ? void 0 : _a.id) {
                yield this.getState();
            }
            if (!((_b = this.identity) === null || _b === void 0 ? void 0 : _b.id) ||
                (this.identity.id && verified && this.identity.isNewUser)) {
                if (!((_c = this.identity) === null || _c === void 0 ? void 0 : _c.id)) {
                    redirectUrl = encodeURIComponent(redirectUrl);
                }
                else if (this.identity.id && verified && this.identity.isNewUser) {
                    dialogType = constants_1.ScreenConstants.COMPLETE_REGISTER;
                }
                const url = `${env_config_1.default.OPENSOOQ_SSO_BASE_DOMAIN}/login?redirectUrl=${redirectUrl}&cityId=${cityId}&country=${country}&deviceUUID=${deviceUUID}&platform=${platform}&language=${language}&dialogType=${dialogType}`;
                window.location.href = url;
            }
            else {
                if (window.location.href !== redirectUrl) {
                    window.location.href = redirectUrl;
                }
            }
        });
    }
    getIdentity() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getState();
            return this.identity;
        });
    }
    setAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            this.auth = yield (0, tgtHelper_1.generateRequiredCookiesAndGetToken)(this.platform);
        });
    }
    changePassword(onContinueCb = () => { }) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.getState();
            if (state === interfaces_1.EnumLoginState.LoggedIn) {
                this.screenType = constants_1.ScreenConstants.CHANGE_PASSWORD;
                this.memberData = yield this.getIdentity();
                window[constants_1.ON_CONTINUE_CB] = onContinueCb;
                document.dispatchEvent(new CustomEvent(constants_1.OPEN_SSO_MODAL_EVENT, {
                    detail: {
                        country: this.country,
                        deviceUUID: this.auth.deviceUUID,
                        platform: this.platform,
                        language: this.language,
                        cityId: this.cityId,
                    },
                }));
            }
            else {
                yield this.getToken(true, true);
            }
        });
    }
    changeMobilePhone(onContinueCb = () => { }) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.getState();
            if (state === interfaces_1.EnumLoginState.LoggedIn) {
                this.screenType = constants_1.ScreenConstants.CHANGE_PHONE_NUMBER;
                this.memberData = yield this.getIdentity();
                window[constants_1.ON_CONTINUE_CB] = onContinueCb;
                document.dispatchEvent(new CustomEvent(constants_1.OPEN_SSO_MODAL_EVENT, {
                    detail: {
                        country: this.country,
                        deviceUUID: this.auth.deviceUUID,
                        platform: this.platform,
                        language: this.language,
                        cityId: this.cityId,
                    },
                }));
            }
            else {
                yield this.getToken(true, false);
            }
        });
    }
    getBaseDomain() {
        return this.domainName;
    }
    destroy() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const cookies = (0, helpers_1.parseCookies)();
            const fcmToken = (_a = cookies[constants_1.CookiesConstants.FIREBASE_FCM_TOKEN]) !== null && _a !== void 0 ? _a : null;
            if (this.identity) {
                try {
                    yield (0, logout_1.logout)(fcmToken);
                }
                catch (err) {
                    console.error(`Error while getting member data`, err);
                }
            }
            const logoutCookies = [
                constants_1.CookiesConstants.AUTH,
                constants_1.CookiesConstants.USER_INFO,
                constants_1.CookiesConstants.AUTH_V2,
            ];
            logoutCookies.forEach((logoutCookie) => {
                (0, helpers_1.destroyCookie)(logoutCookie);
            });
            delete this.identity;
            delete this.auth;
            this.initCalled = false;
            delete this.state;
        });
    }
}
exports.default = Auth;
